"use client";

import { urlForImage } from "@/sanity/lib/image";
import Image from "next/image";
import { Carousel } from "react-responsive-carousel";

import "react-responsive-carousel/lib/styles/carousel.min.css";
type Props = {
  data: any;
};

const ImageGallery = (props: Props) => {
  const { data } = props;
  const renderCustomThumbnails = () => {
    const thumbList = data.imageList.map((image: any, key: number) => {
      return (
        // <div
        //   key={key}
        //   className="relative flex-1 w-[208px] h-[124px] rounded-[16px]"
        // >
        //   <picture>
        <Image
          key={key}
          src={urlForImage(image).format("webp").url()}
          alt={data.title}
          width={208}
          height={124}
          className="rounded-[16px]"
        />
        //   </picture>
        // </div>
      );
    });
    return thumbList;
  };
  return (
    <section>
      <Carousel
        showIndicators={false}
        showStatus={false}
        className="carousel_custom"
        renderThumbs={renderCustomThumbnails}
      >
        {data.imageList.map((image: any, key: number) => {
          return (
            <div
              key={key}
              className="relative w-full max-w-[1128px] max-h-[214px] sm:max-h-[676px] aspect-square "
            >
              <picture>
                {/* TEST */}
                <Image
                  src={urlForImage(image).format("webp").url()}
                  alt={data.title}
                  layout="fill"
                  objectFit="cover"
                  className="rounded-[16px]"
                />
              </picture>
            </div>
          );
        })}
      </Carousel>
    </section>
  );
};

export default ImageGallery;
